import React from 'react'

function ApplyHere() {
  
   
  return (
    <>
      <div id="sur-container">

<h1 id="title">Job form</h1>

<p id="description">Fill in to apply</p>

<form id="survey-form" method='post'>

  
  <label id="name-label" className="row-label" for="name">Name:</label>
  <input id="name" className="row-input" type="text" 
   name="name" placeholder="Enter your name" required/>

  
  <label id="email-label" className="row-label" for="email">Email:</label>
  <input id="email" className="row-input" type="email" name="email" 
  placeholder="Enter your email" required/>

 
  <label className="row-label" for="dropdown">Level of education:</label>
  <select id="dropdown" className="row-input" required>
    <option disabled selected>Select an option</option>
    <option value="primary">Primary education</option>
    <option value="secondary">Secondary education</option>
    <option value="higher">Higher education</option>
    <option value="na">No answer</option>
  </select>

  <label className="row-label" for="dropdown">How did you find out about us?</label>
  <select id="dropdown" className="row-input" required>
    <option disabled selected>Select an option</option>
    <option value="primary">Facebook</option>
    <option value="secondary">Linkedin</option>
    <option value="higher">Indeed</option>
    <option value="na">Instagram</option>
  </select>

  <label id="phone" className="row-label" for="phone">Phone Number:</label>
  <input id="phone" className="row-input" type="phone" name="phone" placeholder="Enter your number" required/>

  {/* <label id="phone" className="row-label" for="phone">Phone Number:</label>
  <input id="phone" className="row-input" type="phone-number" 
  name="phone" placeholder="Enter your phone number" required/> */}


  <label id="number-label" className="row-label" for="number">Years of experience (optional):</label>
  <input id="number" className="row-input" type="number" placeholder="Enter number of years of experience" min="0" max="50"/>

 
  <p className="row-label">What are you interested in?</p>

  <label className="row-input small" for="box-windows" style={{width:"fit-content"}}>
    <input type="checkbox" id="box-windows" name="checkbox" />
    <span className="inline-label">Tele Calling</span>
  </label>

  <label className="row-input small" for="box-word" style={{width:"fit-content"}}>
    <input type="checkbox" id="box-word" name="checkbox" value="salesexecutive"/>
    <span className="inline-label">Sales Executive</span>
  </label>

  <label className="row-input small" for="box-excel" style={{width:"fit-content"}}>
    <input type="checkbox" id="box-excel" name="checkbox" value="fullstackdeveloper"/>
    <span className="inline-label">Full Stack Developer</span>
  </label>

  <label className="row-input small" for="box-powerpoint" style={{width:"fit-content"}}>
    <input type="checkbox" id="box-powerpoint" name="checkbox" value="graphicdesigner"/>
    <span className="inline-label">Graphic Designer</span>
  </label>

  <label className="row-input small" for="box-outlook" style={{width:"fit-content"}}>
    <input type="checkbox" id="box-outlook" name="checkbox" value="other"/>
    <span className="inline-label">Other</span>
  </label>

  <p className="row-label" style={{width:"fit-content"}}>Expected salary:</p>

  <label className="row-input small" for="below-3k" style={{width:"fit-content"}}>
    <input type="radio" id="below-3k" name="radio" value="below-3k"/>
    <span className="inline-label">Below ₹15K</span>
  </label>

  <label className="row-input small" for="3k-4k" style={{width:"fit-content"}}>
    <input type="radio" id="3k-4k" name="radio" value="3k-4k"/>
    <span className="inline-label">₹15K - ₹20K</span>
  </label>

  <label className="row-input small" for="4k-5k" style={{width:"fit-content"}}>
    <input type="radio" id="4k-5k" name="radio" value="4k-5k"/>
    <span className="inline-label">₹20K - ₹25K</span>
  </label>

  <label className="row-input small" for="above-5k" style={{width:"fit-content"}}>
    <input type="radio" id="above-5k" name="radio" value="above-5k"/>
    <span className="inline-label">Above ₹25K</span>
  </label>

  <label className="row-input small" for="dont-know" style={{width:"fit-content"}}>
    <input type="radio" id="dont-know" name="radio" value="dont know"/>
    <span className="inline-label">Don't know</span>
  </label>

  <label className="row-label" for="comments">Additional informations:</label>
  <textarea id="comments" placeholder="Enter other informations here..."></textarea>

  <div>
  <label id="file" className="row-label" for="file">Upload Your CV:</label>
  <input id="file" className="  " type="file" name="file" required/>

{/* <label for="file">Upload Your CV:
  </label>
<input type="file" name="file"/> */}
  </div>
  <br/>
  
  <button type="submit" className="button_1" style={{backgroundColor:"#f79500"}}>Submit</button>

</form>
</div>
    </>
  )
}

export default ApplyHere